import { React, useEffect, useState } from 'react';
import { faFilePdf, faFileCode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import AmpAccordian from '../../../components/common/AmpAccordian/AmpAccordian';
import propertyImg from '../TempData/scroll_house_default.png';
import { activeArray, accordionDataArray } from '../TempData/TempData';
import downloadIcon from '../TempData/download-icon.png';
import AmpLoadingSpinner from '../../common/AmpLoadingSpinner/AmpLoadingSpinner';
import '../../../components/common/AmpAccordian/AmpAccordian.css';
import './MyPropertyDetails.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/reducers/root';
import { downloadResidentialProfilePdf, resetResidentialProfile } from '../../../redux/actions/documents/resendentialProfile';
import { setToastNotification } from '../../../redux/actions/toastNotification/toastNotification';
import { downloadTenantProfile } from '../../../redux/actions/tenantProfile/tenantProfile';
import AmpInlineLoadingSpinner from '../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner';
import { ResidentialProfileState } from '../../../redux/reducers/getDocumentReducer/residentialProfile';
import { TenantProfileState } from '../../../redux/reducers/getTenantProfileReducer/tenantProfileReducer';
import { getPropertySelectionList } from '../../../redux/actions/propertySelectionList/propertySelectionList';

export default function MyPropertyDetails(props: { loading: boolean, propsData: {}, group: string; }) {
    const { t } = useTranslation(['property']);
    const [expandAll, setExpandAll] = useState(false);
    const [active, setActive] = useState(activeArray);
    const [accordionData, setAccordionData] = useState(accordionDataArray);
    const [showTenantProfile, setShowTenantProfile] = useState(false)
    const downloadPdf = useSelector((state: RootState) => state.docReducer.downloadPdf) as ResidentialProfileState;
    const tenantProfile = useSelector((state: RootState) => state.tenantProfileReducer.tenantProfile) as TenantProfileState;
    const manageUserInfoState: Record<string, unknown> = useSelector((state: RootState) => state.authReducer.getUser);
    const group = props.group
    const { loading, propsData } = props
    const dispatch = useDispatch();

    useEffect(() => {
        setAccordionData(accordionDataArray)
        const propertyCd = localStorage.getItem("propertyCode")
        const tenantProfileCodes = [102, 103, 107, 108, 229, 240, 241, 242, 243, 244, 245, 307, 363, 364, 371, 372, 382, 383, 450, 451, 460, 461, 462, 463, 465, 486, 490, 491, 492, 493, 735, 736, 760]
        setShowTenantProfile(propertyCd && tenantProfileCodes.includes(parseInt(propertyCd)) ? true : false)
        const roll = window.localStorage.getItem('currentProperty');
        if (roll && !tenantProfile.tenantProfile && propertyCd && tenantProfileCodes.includes(parseInt(propertyCd))) {
            let userLanguage = window.localStorage.getItem('prefLang');
            if (!userLanguage) {
                if (manageUserInfoState.pref_lang) {
                    userLanguage = manageUserInfoState.pref_lang as string;
                } else {
                    userLanguage = 'en_EN';
                }
            }
            dispatch(downloadTenantProfile(roll, userLanguage));
        }
    }, [dispatch, manageUserInfoState.pref_lang, tenantProfile.tenantProfile])

    const formatTitle = (active: boolean, title: string) => {
        const tempTitle = 'accordion.' + title
        const formattedTitle = t(tempTitle).toUpperCase() as string
        return active ? '[ - ] ' + formattedTitle : '[ + ] ' + formattedTitle
    }

    useEffect(() => {
        if (!downloadPdf.loading && downloadPdf.found && downloadPdf.roll) {
            const tempLink = document.createElement('a');
            if (downloadPdf.is_link && downloadPdf.pdf) {
                tempLink.download = `Property_Profile_Report-${downloadPdf.roll.substring(0, 15)}.pdf`;
                tempLink.href = downloadPdf.pdf;
            } else if (downloadPdf.pdf) {
                tempLink.download = `Property_Profile_Report-${downloadPdf.roll.substring(0, 15)}.pdf`;
                tempLink.href = 'data:application/octet-stream;base64,' + downloadPdf.pdf;
            } else if (downloadPdf.html) {
                tempLink.download = `Property_Profile_Report-${downloadPdf.roll.substring(0, 15)}.html`;
                const data = new Blob([downloadPdf.html], { type: "application/html" })
                tempLink.href = URL.createObjectURL(data);
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            tempLink.remove();
            dispatch(resetResidentialProfile());
            const userProfileId = localStorage.getItem("userProfileId");
            userProfileId && dispatch(getPropertySelectionList(userProfileId));
        } else if (!downloadPdf.loading && downloadPdf.found === false) {
            dispatch(setToastNotification('Profile Report not found!', 'error'));
        }
    }, [downloadPdf.loading, downloadPdf.pdf, downloadPdf.html, downloadPdf.roll, downloadPdf.found, downloadPdf.is_link, dispatch]);

    const AccordionContainer = (props: { i: number; title: string; value: string; data: []; }) => {
        if (props.title === 'accordion.improvements.suites' && Array.isArray(props.value)) {
            const value = props.value
            const jsx = [];
            for (let i = 0; i < value.length; i++) {
                for (const [k, v] of Object.entries(value[i])) {
                    jsx.push(<div className='info-container' key={props.i}>
                        <div className='info-row'>
                            <div className='info-title'>{k as string}</div>
                            <div className='info-value'>{v as string}</div>
                        </div>
                    </div>)
                }
                if (i !== value.length - 1) {
                    jsx.push(<hr />)
                }
            }
            return <>{jsx}</>
        } else {
            const value = props.value?.toString() || 'N/A'
            return <div className='info-container' key={props.i}>
                <div className='info-row'>
                    <div className='info-title'>{t(props.title) as string}</div>
                    <div className='info-value'>{value}</div>
                </div>
                {props.i !== props.data.length - 1 && <hr />}
            </div>
        }
    }
    const formatData = (id: string, data: []) => {
        return (
            <>
                {data.length ? data.map((e: { id: string, title: string, value: string }, i: number) => {
                    if (id === 'primary_structures' || id === 'secondary_structures' || id === 'improvements') {
                        return <div key={e.id + i}>
                            <div className='structure-heading' data-testid='structure-heading'>{id === 'improvements' ? <>Component</> : <>Structure</>}</div>
                            {data[i].length && data[i].map((el: { title: string; id: number; value: string; }, idx: number) => {
                                const title = 'accordion.' + el.title
                                return (
                                    <span className='acc-container' key={el.id + i}>
                                        <AccordionContainer data={data[i]} i={idx} title={title} value={el.value} />
                                    </span>
                                );
                            })}
                        </div>
                    } else {
                        if (e.id === 'hos_name') {
                            return <div key={e.id + i}>{e.value}</div>
                        } else {
                            const title = 'accordion.' + e.title
                            return (
                                <span className='acc-container' key={e.id + i}>
                                    <AccordionContainer data={data} i={i} title={title} value={e.value} />
                                </span>
                            );
                        }
                    }
                    return <></>
                }) : <></>}
            </>
        );
    };

    const downloadProfileReport = (html: string) => {
        const userProfileId = window.localStorage.getItem('userProfileId');
        const roll = window.localStorage.getItem('currentProperty');
        if (!roll || !userProfileId) {
            dispatch(setToastNotification('Missing information', 'error'));
        } else {
            let userLanguage = window.localStorage.getItem('prefLang');
            const oType = localStorage.getItem("o_type") as string;
            if (!userLanguage) {
                if (manageUserInfoState.pref_lang) {
                    userLanguage = manageUserInfoState.pref_lang as string;
                } else {
                    userLanguage = 'en_EN';
                }
            }
            dispatch(downloadResidentialProfilePdf(userProfileId, roll, userLanguage, html, oType));
        }
    }

    return (
        <div className='property-content'>
            <AmpLoadingSpinner loading={loading}>
                <div className='property-container'>
                    {!loading && <div>
                        <div className='property-view-image'>
                            <div className='property-image'>
                                <img src={propertyImg} alt='' />
                            </div>
                            <div className='download-btn'>
                                <div className='download-contents profile-report'>
                                    <div>
                                        {downloadPdf.loading ?
                                            <div className='download-icon'><div className='spinner-parent'><AmpInlineLoadingSpinner /></div></div> :
                                            <img
                                                src={downloadIcon}
                                                className='download-icon'
                                                alt=''
                                            />
                                        }
                                        <span className='res-download-text'>
                                            <div>
                                                {t('download-btns.download') as string}
                                            </div>
                                            <div>
                                                {
                                                    t(
                                                        'download-btns.current-property-profile-report'
                                                    ) as string
                                                }
                                            </div>
                                        </span>

                                    </div>
                                    <div className='dropdown-content'>
                                        <p className='report-icon-container'><button className='report-button' onClick={() => {
                                            if (!downloadPdf['loading']) {
                                                downloadProfileReport("N")
                                            }
                                        }}><FontAwesomeIcon icon={faFilePdf} className='report-icon' />PDF</button></p>
                                        {group === "res" ? <p className='report-icon-container'><button className='report-button' onClick={() => {
                                            if (!downloadPdf['loading']) {
                                                downloadProfileReport("Y")
                                            }
                                        }}><FontAwesomeIcon icon={faFileCode} className='report-icon' />HTML</button></p> : <></>}
                                    </div>
                                </div>
                                {showTenantProfile ?
                                    <div className='download-contents profile-report' onClick={() => {
                                        const zip = tenantProfile.tenantProfile?.zip
                                        if (zip) {
                                            window.open(zip)
                                        }
                                    }}>
                                        <img
                                            src={downloadIcon}
                                            className='download-icon'
                                            alt=''
                                        />
                                        <span className='res-download-text'>
                                            <div>
                                                {t('download-btns.download') as string}
                                            </div>
                                            <div>
                                                {
                                                    t(
                                                        'download-btns.tenant-camper-profiles'
                                                    ) as string
                                                }
                                            </div>
                                        </span>
                                    </div> : <></>
                                }
                                <div className='download-contents' onClick={() => {
                                    const a = document.createElement('a')
                                    const prefLang = localStorage.getItem('prefLang');
                                    if (prefLang === 'en') {
                                        if (group === 'res') {
                                            a.href = 'Profile_Glossary_en.pdf'
                                        } else {
                                            a.href = 'Profile_Glossary_en_nonres.pdf'
                                        }
                                        a.download = 'Profile_Glossary_EN.pdf'
                                    } else if (prefLang === 'fr') {
                                        if (group === 'res') {
                                            a.href = 'Profile_Glossary_fr.pdf'
                                        } else {
                                            a.href = 'Profile_Glossary_fr_nonres.pdf'
                                        }
                                        a.download = 'Profile_Glossary_FR.pdf'
                                    }
                                    document.body.appendChild(a)
                                    a.click()
                                    document.body.removeChild(a)
                                }}>
                                    <img
                                        src={downloadIcon}
                                        className='download-icon'
                                        alt=''
                                    />
                                    <span>
                                        <div>
                                            {t('download-btns.download') as string}
                                        </div>
                                        <div>
                                            {
                                                t(
                                                    'download-btns.profile-glossary'
                                                ) as string
                                            }
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className='accordion-container'>
                            <div className='amp-accordian-element'>
                                <h3
                                    data-testid='expand-header'
                                    className='accordian-title'
                                    onClick={() => {
                                        for (let i = 0; i < active.length; i++) {
                                            active[i].active = expandAll ? false : true;
                                        }
                                        setExpandAll(!expandAll);
                                    }}
                                >
                                    {expandAll ? (
                                        <>
                                            [ - ]{' '}
                                            {
                                                t(
                                                    'accordion.collapse-all'
                                                ).toUpperCase() as string
                                            }
                                        </>
                                    ) : (
                                        <>
                                            [ + ]{' '}
                                            {
                                                t(
                                                    'accordion.expand-all'
                                                ).toUpperCase() as string
                                            }
                                        </>
                                    )}
                                </h3>
                            </div>
                            {accordionData.map((e, i) => {
                                if (propsData[e.id]) {
                                    return (
                                        <div
                                            key={i}
                                            onClick={() => {
                                                const temp = active;
                                                if (temp[i]) {
                                                    temp[i].active = !temp[i]?.active;
                                                }
                                                setActive([...temp]);
                                            }}
                                            data-testid={e.id}
                                        >
                                            <AmpAccordian
                                                title={formatTitle(active[i]?.active, e.title)}
                                                content={
                                                    <div>
                                                        {formatData(e.id, propsData[e.id])}
                                                    </div>
                                                }
                                                isOpen={active[i]?.active}
                                            />
                                        </div>
                                    );
                                } else {
                                    return <></>
                                }
                            })}
                        </div>
                    </div>
                    }
                </div>
            </AmpLoadingSpinner>
        </div>
    );
}


